import feeSetup from '@/api/fee-setup'
import mainProgramAPI from '@/api/main-program'
import sbuProgramAPI from '@/api/sub-program'
import levelAPI from '@/api/level'
import gradeAPI from '@/api/grade'
import transportationDistanceAPI from '@/api/transportation-distance'
import transportationWayAPI from '@/api/transportation-way'
import branchAPI from '@/api/branch'
import productAPI from '@/api/product'
import { includes, flatten, uniqBy, filter } from 'lodash'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  edit_data: {},
  mainPrograms: [],
  paymentTerm: [],
  shifts: [],
  distances: [],
  transactions: [],
  branchList: [],
  products: [],
  fee_type_id: [],
  branch_id: null,
  roomTypes: [{ text: 'Normal', value: 1 }, { text: 'Premium', value: 2 }],
  feeTypes: [
    { text: 'Tuition Fee', value: 1 },
    { text: 'Service Fee', value: 2 },
    { text: 'Bus Fee', value: 3 },
    { text: 'Study Material', value: 4 },
    { text: 'Other Material', value: 5 },
    { text: 'others', value: 6 }
  ]
}

export const getters = {
  productListExcludeSelectedProduct: state => ({
    addedProducts,
    excludeProduct
  } = {}) => {
    if (addedProducts != undefined && excludeProduct != undefined) {
      const productFiter = state.products.filter(
        p =>
          !includes(
            addedProducts
              .filter(ap => ap.product_id != excludeProduct)
              .map(s => s.product_id),
            p.product_id
          )
      )
      return uniqBy(
        productFiter.map(el => ({
          product_id: el.product_id,
          product_name_en: el.product_name_en
        })),
        'product_id'
      )
    }
    return uniqBy(
      state.products.map(el => ({
        product_id: el.product_id,
        product_name_en: el.product_name_en
      })),
      'product_id'
    )
  },
  getUom: state => productId => {
    if (productId && state.products.length > 0) {
      let result = state.products.filter(p => p.product_id == productId)
      return result.length > 0
        ? result[0].u_o_mcategory.unit_of_measures.filter(
            u => u.is_default == true
          )[0]
        : ''
    }

    return {
      uom_id: '',
      uom_name_en: ''
    }
  },
  productPrice: state => (productId, uomId) => {
    try {
      return flatten(
        state.products.find(p => p.product_id == productId).sale_code
      ).find(sc => sc.uom_id == uomId).product_price
    } catch (e) {
      return ''
    }
  }
}

export const mutations = {
  ...baseMutations,
  SET_EDIT_DATA(state, data) {
    state.edit_data = data
  },
  SET_MAIN_PROGRAM(state, data) {
    state.mainPrograms = data
  },
  SET_PAYMENT_TERM(state, data) {
    state.paymentTerm = data
  },
  SET_SHIFT(state, data) {
    state.shifts = data
  },
  SET_DISTANCE(state, data) {
    state.distances = data
  },
  SET_TRANSACTION(state, data) {
    state.transactions = data
  },
  SET_BRANCH(state, data) {
    state.branchList = data
  },
  SET_PRODUCT(state, data) {
    state.products = data
  },
  SET_BRANCH_ID(state, data) {
    state.branch_id = data
  },
  SET_FEE_TYPE_ID(state, data) {
    state.fee_type_id = data
  }
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search,
        fee_type_id: context.state.fee_type_id,
        all_branch: Array.isArray(context.state.branch_id)
          ? context.state.branch_id.length
            ? undefined
            : true
          : true
      },
      attrubutes
    )
    return feeSetup.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },

  store(context, data) {
    return feeSetup.store(data)
  },

  update(context, data) {
    return feeSetup.update(data)
  },

  destroy(context, id) {
    return feeSetup.destroy(id)
  },
  synAmount(context, id) {
    return feeSetup.synAmount(id)
  },
  exportExcel(context, payload) {
    return feeSetup.exportExcel(payload)
  },

  async find(context, id) {
    if (_.isEmpty(context.state.edit_data)) {
      let response = await feeSetup.find(id)
      context.commit('SET_EDIT_DATA', response.data)
    }
  },

  async getPaymentTerm(context) {
    if (!context.state.paymentTerm.length > 0) {
      let response = await feeSetup.paymentTerm()
      context.commit('SET_PAYMENT_TERM', response.data)
      return response
    }
  },
  async getShift(context) {
    if (!context.state.shifts.length > 0) {
      let response = await feeSetup.shift()
      context.commit('SET_SHIFT', response.data)
      return response
    }
  },
  async getMainProgram(context) {
    if (!context.state.mainPrograms.length > 0) {
      let response = await mainProgramAPI.get({
        params: {
          page: -1,
          'fields[academic_program_mains]': 'acp_id,acp_name_foreign'
        }
      })

      context.commit('SET_MAIN_PROGRAM', response.data)

      return response
    }
  },
  async getDistance(context) {
    if (!context.state.distances.length > 0) {
      let response = await transportationDistanceAPI.get({
        params: {
          page: -1,
          'fields[setup_transportation_distances]':
            'distance_id,distance_description'
        }
      })
      context.commit('SET_DISTANCE', response.data)
      return response
    }
  },
  async getTransaction(context) {
    if (!context.state.transactions.length > 0) {
      let response = await transportationWayAPI.get({
        params: {
          page: -1,
          'fields[setup_transportation_ways]': 'way_id,way_description'
        }
      })
      context.commit('SET_TRANSACTION', response.data)
      return response
    }
  },
  async getSubProgram(context, mainId) {
    return await sbuProgramAPI.get({
      params: {
        page: -1,
        'fields[academic_program_subs]': 'acps_id,acps_name_foreign',
        filter: {
          acp_id: mainId,
          is_active: 1
        }
      }
    })
  },
  async getLevel(context, acps_id) {
    return await levelAPI.get({
      params: {
        page: -1,
        'fields[academic_program_levels]': 'level_id,level_name_foreign',
        'filter[acps_id]': acps_id
      }
    })
  },
  async getGrade(context, level_id) {
    try {
      const response = await gradeAPI.get({
        params: {
          page: -1,
          'fields[academic_program_level_grades]':
            'grade_id,grade_name_foreign',
          'filter[academic_program_level_grades.level_id]': level_id,
          'filter[academic_program_level_grades.is_active]': 1
        }
      })

      // Additional client-side filter as backup
      // Only filter if is_active field exists in the response
      if (response.data && Array.isArray(response.data)) {
        // Check if any grade has is_active field
        const hasIsActiveField = response.data.some(
          grade => 'is_active' in grade
        )

        if (hasIsActiveField) {
          // Filter only if is_active field exists
          response.data = response.data.filter(
            grade => grade.is_active === 1 || grade.is_active === true
          )
        }
        // If no is_active field, return all grades (backend already filtered)
      }

      return response
    } catch (error) {
      console.error('Error fetching grades:', error)
      return { data: [] }
    }
  },
  async getBranch(context, attrubutes = {}) {
    if (!context.state.branchList.length > 0) {
      let params = Object.assign(
        {
          page: -1,
          'fields[setup_branch_profiles]': 'branch_id,branch_name_en'
        },
        attrubutes
      )
      let response = await branchAPI.get({ params })
      context.commit('SET_BRANCH', response.data)
    }
  },
  async getProduct(context) {
    if (!context.state.products.length > 0) {
      let response = await productAPI.get({
        params: {
          page: -1,
          include: 'uOMcategory.unitOfMeasures,saleCode.productPrice',
          filter: {
            location_base: true,
            has_provided_sale_code: true,
            price_set: true
          },
          fields: {
            sale_code: 'pro_sale_code_id,product_id,uom_id,sale_code'
          }
        }
      })
      context.commit('SET_PRODUCT', response.data)
      return response
    }
  },
  copyFee(context, data) {
    return feeSetup.copyFee(data)
  },
  setInactive(context, feeSetupId) {
    return feeSetup.setInactive(feeSetupId)
  }
}
